import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { createStyles, withStyles } from '@mui/styles';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { FormType } from '../../../constants/constants';
import { resetCustomers } from '../../../reducers/customerReducer';
import { resetCancellationRuleSets } from '../../../reducers/cancellationRuleSetReducer';
import { RootState } from '../../../setup';
import AddCustomerCancellationRuleSetForm from './addCustomeCancellationRuleSetForm';

interface IAddCustomerCancellationRuleSetProps {
    classes: any;
    theme: Theme;
    match: any;
    resetCustomers: any;
    resetCancellationRuleSets: any;
    steps: Array<number>;
    customerId?: number;
    cancellationRuleSetId?: number;
    customerCancellationRuleSetId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetCustomers: () => dispatch(resetCustomers()),
    resetCancellationRuleSets: () => dispatch(resetCancellationRuleSets())
});

const mapStoreToProps = (store: RootState, ownProps: IAddCustomerCancellationRuleSetProps) => {
    return {
        customerId: ownProps.match.params?.customerId ? Number(ownProps.match.params?.customerId) : undefined,
        cancellationRuleSetId: ownProps.match.params?.cancellationRuleSetId ? Number(ownProps.match.params?.cancellationRuleSetId) : undefined,
        customerCancellationRuleSetId: ownProps.match.params?.customerCancellationRuleSetId ? Number(ownProps.match.params?.customerCancellationRuleSetId) : undefined
    };
};

class AddCustomerCancellationRuleSet extends Component<IAddCustomerCancellationRuleSetProps> {

    componentWillUnmount() {
        const { resetCustomers, resetCancellationRuleSets } = this.props;

        resetCustomers();
        resetCancellationRuleSets();
    }

    render() {
        const { classes, steps, customerId, cancellationRuleSetId, customerCancellationRuleSetId, type } = this.props;

        return (
            <div>
                <Card className={classes.root}>
                    <CardContent className={classes.cardContent}>
                        <AddCustomerCancellationRuleSetForm customerId={customerId} cancellationRuleSetId={cancellationRuleSetId}
                            customerCancellationRuleSetId={customerCancellationRuleSetId} steps={steps} type={type}
                        />
                    </CardContent>
                </Card>
            </div>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddCustomerCancellationRuleSet));